<!--
 * @Author: lan.h
 * @Date: 2022-02-14 16:45:24
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-13 15:52:02
 * @Description: 快讯
-->
<template>
  <div>
    <div class="news-live">
      <div class="n-title">
        <img :src="$store.state.static_img_url+'pic/topic.png'" alt="快讯">
        <div>
          <h2 class="h2" v-if="item.newsTopicType && item.newsTopicType.length > 0">{{item.newsTopicType[0] | deal('news_topic_type')}}</h2>
          <a class="h1" target="_blank" :href="$store.state.index2_path + '/newsDetail/' + item.uid">{{item.title}}</a>
        </div>
      </div>

      <div class="n-desc">
        <div v-if="is_open" @click="is_open = !is_open" class="open-btn">展开</div>
        <div class="n-desc-sum" :style="{height: !is_open ? 'auto' : '66px'}">
          <div :class="'summary' + item.id" v-html="item.summary"></div>
        </div>
      </div>
      <div class="n-option">
        <div class="bot_cnt">
          <div class="tags1" v-if="item.tracks && item.tracks.length > 0">
            <span>相关赛道</span>
            <a v-for="tag,tag_index in item.tracks" :key="tag" v-if="tag_index < 3" @click="toTrack(tag)">{{tag | dealNeed(entityNtag)}}</a>
          </div>
        </div>
        <div class="option-right">
          <div class="n-share">
            <span>分享至</span>
            <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item.uid)" @on-popper-hide="haddleShareHide">
              <i class="iconfont w">&#xe641;</i>
              <div slot="content" class="share_cnt clear">
                <div class="share_img"></div>
                <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
              </div>
            </Poptip>
          </div>
          <div class="theme-time">
            <div>
              <span>{{item.publishTime | time_standard}}</span>
              <i class="iconfont s active" title="取消收藏" v-if="item.isCollect" @click.stop="cancelCollect('0', item.id, delCollectCb)">&#xe66f;</i>
              <i class="iconfont s" title="收藏" v-else @click.stop="addCollect('0', item.id, addCollectCb)">&#xe66f;</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Entity v-if="item.entityInfos && item.entityInfos.length > 0" :entityInfos="item.entityInfos"></Entity>
  </div>
</template>

<script>
import Entity from './Entity'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [collect_mixin],
  props: ['item', 'isCollect', 'entityNtag'],
  data() {
    return {
      is_open: false,
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
  },
  created() {
    this.$nextTick(() => {
      if ($('.summary' + this.item.id).height() > 66) {
        this.is_open = true
      }
    })
  },
  components: { Entity },
  methods: {
    addCollectCb() {
      this.item.isCollect = true
    },
    delCollectCb() {
      this.item.isCollect = false
    },
    haddleShare(uid) {
      let share_link = this.$store.state.index2_path + '/News/newsDetail?uid=' + uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link,
      })
      // _czc.push(['_trackEvent', '动脉橙首页快讯', '快讯列表页分享入口'])
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    toTrack(tag) {
      const href = this.$store.state.index_path + '/trackDetail?tag=' + tag
      window.open(href, '_blank')
    },
    toTopic() {
      const href = this.$store.state.index2_path + '/newsDetail/' + this.item.uid
      window.open(href, '_blank')
    },
  },
}
</script>

<style lang="stylus" scoped>
.news-live
  position relative
  .n-title
    display flex
    flex-flow row nowrap
    img
      margin-right 10px
      height 18px
      margin-top 3px
    >div
      flex 1
  .h2, .h1
    font-size 18px
    line-height 24px
  .h2
    color #FA5A00
    position relative
    padding-right 15px
    display inline
    &::after
      content ''
      right 6px
      top 5px
      background #E9E9E9
      width 1px
      height 16px
      position absolute
  .h1
    color #333333
    margin-top 0
    display inline
    font-weight 550
    transition all 0.5s
    cursor pointer
    &:hover
      color #FA5A00
  .n-desc
    font-size 13px
    color #666666
    line-height 22px
    margin-top 14px
    font-weight 500
    position relative
    .open-btn
      cursor pointer
      color #FA5A00
      position absolute
      right 0
      bottom 0
      background #fff
      width 60px
      text-align right
      &::before
        position absolute
        left 0
        top 0
        content '...'
        color #666
    .n-desc-sum
      overflow hidden
  .n-option
    margin-top 14px
    display flex
    flex-flow row nowrap
    justify-content space-between
    align-items center
    font-size 12px
    .bot_cnt
      height 25px
      flex 1
      .tags1
        a
          background #FFF8F1
          border-radius 13px
          font-size 12px
          
          font-weight 400
          color #FA5A00
          line-height 1
          padding 6px 8px
          display inline-block
          margin-left 10px
          transition all 0.5s
          &:first-child
            margin-left 15px
          &:hover
            background #FA5A00
            color #fff
    .option-right
      display flex
      .theme-time
        color #999
        display flex
        align-items center
        flex-flow row-reverse
        >div
          display flex
          align-items center
        i
          font-size 12px
          margin-right 6px
          height 11px
          display inline-block
          line-height 1
        .s
          margin-right 0
          width 18px
          height 18px
          text-align center
          line-height 18px
          color #ccc
          background-color #f3f3f3
          border-radius 2px
          font-size 10px
          display inline-block
          cursor pointer
          margin-left 10px
          vertical-align -webkit-baseline-middle
          &.s:hover, &.s.active
            color #fff
            background rgba(250, 122, 80, 1)
          &.w:hover, &.w.active
            color #fff
            background #63BF61
  .n-share
    color #999999
    position relative
    margin-right 25px
    line-height 18px
    .w
      width 18px
      height 18px
      background #F3F3F3
      border-radius 2px
      padding 3px
      color #CCCCCC
      font-size 12px
      transition all 0.5s
    .w:hover, .w.active
      color #fff
      background #63BF61
    >>> .ivu-poptip
      margin-left 8px
      .ivu-poptip-rel
        // width 18px
        // height 18px
        cursor pointer
      .ivu-poptip-popper
        transform translate(13px, 0)
        .ivu-poptip-inner
          border-radius 0
          .share_cnt
            padding 10px 20px 10px 10px
            .share_img
              width 80px
              height 80px
              float left
              background #f0f0f0
            p
              line-height 20px
              color #666
              float right
              margin-top 20px
              font-size 14px
</style>